export const ADD_TASK_MILESTONES = 'ADD_TASK_MILESTONES'
export const ADD_TASK_MILESTONE = 'ADD_TASK_MILESTONE'
export const ADD_PROJECT_MILESTONES = 'ADD_PROJECT_MILESTONES'
export const UPDATE_TASK_MILESTONE = 'UPDATE_TASK_MILESTONE'
export const DESTROY_TASK_MILESTONE = 'DESTROY_TASK_MILESTONE'